import { useBranch } from '../contexts/BranchContext';

/**
 * แสดงเฉพาะในแอดมิน — แอปพนักงานคนละตัว ไม่มีคอมโพเนนต์นี้เลย เจ้าของร้านเห็น dropdown
 * สลับได้ทุกสาขา ส่วนผู้จัดการสาขา (login แอดมินได้แล้วแต่ล็อกไว้สาขาเดียว — ดู
 * BranchContext.jsx) จะมี branches แค่ 1 รายการเสมอ เข้าเงื่อนไข "สาขาเดียว" ด้านล่าง
 * โชว์แค่ชื่อสาขาเฉยๆ ไม่มี dropdown ให้สลับ ไม่ต้องเขียนโค้ดแยกอีกชุด
 */
export default function BranchSwitcher() {
  const { branches, loading, selectedBranchId, currentBranch, selectBranch } = useBranch();

  if (loading) {
    return (
      <div style={switcherStyle}>
        <span style={{ opacity: 0.6, fontSize: '0.8rem' }}>กำลังโหลดสาขา...</span>
      </div>
    );
  }

  if (branches.length === 0) {
    return null;
  }

  // สาขาเดียว — ไม่ต้องมี dropdown ให้เลือก แค่บอกว่ากำลังดูสาขาไหนอยู่
  if (branches.length === 1) {
    return (
      <div style={switcherStyle}>
        <span style={labelIconStyle}>🏢</span>
        <span style={{ fontSize: '0.85rem', fontWeight: 600 }}>{branches[0].name}</span>
      </div>
    );
  }

  return (
    <div style={switcherStyle}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', width: '100%' }}>
        <span style={labelIconStyle}>🏢</span>
        <select
          value={selectedBranchId}
          onChange={(e) => selectBranch(e.target.value)}
          style={selectStyle}
        >
          <option value="all">🌐 รวมทุกสาขา (HQ)</option>
          {branches.map(b => (
            <option key={b.id} value={b.id}>{b.name}</option>
          ))}
        </select>
      </label>
      {currentBranch && selectedBranchId !== 'all' && (
        <span style={{ fontSize: '0.7rem', opacity: 0.6, marginTop: '0.25rem' }}>
          รหัส: {currentBranch.code}
        </span>
      )}
    </div>
  );
}

const switcherStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '0.75rem 1rem',
  margin: '0 0 1rem',
  background: 'rgba(255,255,255,0.06)',
  borderRadius: '10px',
  border: '1px solid rgba(255,255,255,0.1)'
};

const labelIconStyle = { fontSize: '1rem' };

const selectStyle = {
  flex: 1,
  padding: '0.4rem 0.5rem',
  borderRadius: '6px',
  border: '1px solid rgba(255,255,255,0.2)',
  background: 'rgba(255,255,255,0.95)',
  color: '#1f2937',
  fontSize: '0.85rem',
  fontWeight: 600,
  cursor: 'pointer'
};
